import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { withRouter } from 'react-router-dom';
import 'react-table/react-table.css';
import {
  Modal,
  ModalBody, ModalFooter,
  ModalHeader,
} from 'reactstrap';

import {
  createLinkUser, deleteLinkUser, getUserList,
} from '../../../../app/store/actions/indirectTasks';
import OneClickButton from '../../../../components/form/button';
import addNotification from '../../../../components/notification';
import Table from '../../../../components/table/Table';

class UserLinkModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      users: [],
    };

    this.defaultSorted = [
      {
        id: 'login',
        desc: false,
      },
    ];

    this.tableColumns = [
      {
        Header: I18n.t('BEE55' /* Ações */),
        accessor: 'action',
        style: { overflow: 'visible', alignSelf: 'center' },
        filterable: false,
        sortable: false,
        width: 100,
        Cell: (rows) => (
          <div style={{ textAlign: 'center' }}>
            {this.hasLink(rows.row._original)
              ? (
                <button
                  type="button"
                  className="btn btn-default btn-xs"
                  onClick={() => this.removeUserLink(rows.row._original)}
                >
                  {I18n.t('BEE608' /* Desvincular */)}
                </button>
              )
              : (
                <button
                  type="button"
                  className="btn btn-default btn-xs"
                  onClick={() => this.createUserLink(rows.row._original)}
                >
                  {I18n.t('BEE601' /* Vincular */)}
                </button>
              )}
          </div>
        ),
      }, {
        Header: I18n.t('BEE623' /* Login */),
        accessor: 'login',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 80,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE83' /* Nome */),
        accessor: 'name',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE145' /* Filial */),
        accessor: 'mainBranch',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 80,
        Filter: this.filterColumn,
      },
    ];
  }

  componentDidMount() {
    this.maintainsState();
  }

  maintainsState = async () => {
    await this.getUser();
  };

  filterColumn = ({ onChange }) => (
    <input
      type="text"
      style={{ width: '100%' }}
      onKeyPress={(event) => {
        if (event.keyCode === 13 || event.which === 13) {
          onChange(event.target.value);
        }
      }}
      onKeyUp={(event) => {
        if (event.target.value === '' && (event.keyCode === 8 || event.which === 8)) {
          onChange(event.target.value);
        }
      }}
    />
  );

  tableTitle = () => {
    const { indirectTaskSelected } = this.props;

    if (indirectTaskSelected) {
      return `${I18n.t('BEE1668' /* Tarefas Indiretas */)}: ${indirectTaskSelected.code} - ${indirectTaskSelected.name
        }`;
    }
    return I18n.t('BEE1690' /* Erro ao buscar a tarefa */);
  };

  hasLink = (user) => {
    if (this.props.indirectTaskSelected) {
      const indirectTaskCode = this.props.indirectTaskSelected.code;
      if (user.userIndirectTasks.length) {
        return user.userIndirectTasks.find((t) => t.indirectTaskCode === indirectTaskCode);
      }
      return false;
    }
    return false;
  };

  getUser = async () => {
    const users = await this.props.getUserList();

    this.setState({
      users,
    });
  };

  createUserLink = async (user) => {
    const userId = user.id;
    const { code, name } = this.props.indirectTaskSelected;

    try {
      const resultado = await this.props.createLinkUser(userId, code);

      if (resultado.id) {
        addNotification(
          'success',
          I18n.t('BEE1668' /* Tarefas Indiretas */),
          I18n.t('BEE1691', {
            0: user.code, 1: user.name, 2: code, 3: name,
          } /* %{0} - %{1} vinculado à tarefa %{2} - %{3} com sucesso! */),
          'top-right',
        );
        await this.getUser();
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        const { error } = err.response.data;

        if (error.details || error.message) {
          addNotification(
            'danger',
            I18n.t('BEE1668' /* Tarefas Indiretas */),
            `${error.code} - ${error.details || error.message}`,
            'top-right',
          );
        } else {
          addNotification(
            'danger',
            I18n.t('BEE1668' /* Tarefas Indiretas */),
            I18n.t('BEE1692', { 0: code } /* Erro ao incluir a tarefa %{0} */),
            'top-right',
          );
        }
      } else {
        addNotification(
          'danger',
          I18n.t('BEE1668' /* Tarefas Indiretas */),
          I18n.t('BEE1692', { 0: code } /* Erro ao incluir a tarefa %{0} */),
          'top-right',
        );
      }
    }
  };

  removeUserLink = async (user) => {
    const { code, name } = this.props.indirectTaskSelected;

    try {
      const userIndirectTasks = this.hasLink(user);
      if (userIndirectTasks) {
        const resultado = await this.props.deleteLinkUser(userIndirectTasks.id);

        if (resultado === 1) {
          addNotification(
            'success',
            I18n.t('BEE1668' /* Tarefas Indiretas */),
            I18n.t('BEE1693', {
              0: user.code, 1: user.name, 2: code, 3: name,
            } /* %{0} - %{1} desvinculado da Range %{2} - %{3} com sucesso! */),
            'top-right',
          );
          await this.getUser();
        }
      } else {
        throw new Error(I18n.t('BEE808' /* Vínculo com a Range não encontrado */));
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        const { error } = err.response.data;

        if (error.details || error.message) {
          addNotification(
            'danger',
            I18n.t('BEE1668' /* Tarefas Indiretas */),
            `${error.code} - ${error.details || error.message}`,
            'top-right',
          );
        } else {
          addNotification(
            'danger',
            I18n.t('BEE1668' /* Tarefas Indiretas */),
            I18n.t('BEE1692', { 0: code } /* Erro ao incluir a tarefa %{0} */),
            'top-right',
          );
        }
      } else {
        addNotification(
          'danger',
          I18n.t('BEE1668' /* Tarefas Indiretas */),
          I18n.t('BEE1692', { 0: code } /* Erro ao incluir a tarefa %{0} */),
          'top-right',
        );
      }
    }
  };

  render() {
    const { showUserLinkModal } = this.props;

    const { users = [] } = this.state;

    const title = I18n.t('BEE620' /* Vincular Usuários */);

    return (
      <Modal size="lg" isOpen={showUserLinkModal} toggle={() => this.props.closeUserLinkModal()}>
        <ModalHeader toggle={() => this.props.closeUserLinkModal()}>{title}</ModalHeader>
        <ModalBody>
          <Table
            headerTitle={this.tableTitle()}
            panelHeaderProps={{ noButton: true }}
            filterable
            data={users}
            columns={this.tableColumns}
            expander
            defaultPageSize={5}
            pageSizeOptions={[5, 10]}
            defaultSorted={this.defaultSorted}
            defaultFilterMethod={(filter, row) => {
              const input = _.lowerCase(filter.value);
              const value = _.lowerCase(row[filter.id]);
              if (_.includes(value, input)) {
                return true;
              }
            }}
          />
        </ModalBody>
        <ModalFooter>
          <div className="row">
            <div className="col text-right">
              <OneClickButton
                className="btn btn-white btn-120 p-5 m-5"
                onClick={() => this.props.closeUserLinkModal()}
              >
                {I18n.t('BEE137' /* Voltar */)}
              </OneClickButton>
            </div>
          </div>
        </ModalFooter>
      </Modal>
    );
  }
}

const mapStateToProps = () => ({
});

const mapDispatchToProps = (dispatch) => ({
  getUserList: (tableParams) => dispatch(getUserList(tableParams)),
  createLinkUser: (userId, rangeCode) => dispatch(createLinkUser(userId, rangeCode)),
  deleteLinkUser: (userIndirectTasksId) => dispatch(deleteLinkUser(userIndirectTasksId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UserLinkModal));
